import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _parseInt from "@babel/runtime-corejs3/core-js-stable/parse-int";
import _Math$hypot from "@babel/runtime-corejs3/core-js-stable/math/hypot";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _setTimeout from "@babel/runtime-corejs3/core-js-stable/set-timeout";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import React, { useRef, useState, useCallback, useEffect } from 'react';
import { usePopper } from 'react-popper';
import { useStyles, StyleSheet } from '@rexlabs/styling';
import { noop } from 'lodash';
var defaultArrowSize = 12;
var defaultArrowMargin = 4;
var defaultArrowPadding = 8;
var defaultStyles = StyleSheet({
  popper: {
    filter: function filter(_ref) {
      var token = _ref.token;
      return token('popout.filter', token('shadow.menuFilter'));
    },
    zIndex: function zIndex(_ref2) {
      var token = _ref2.token;
      return token('popout.zIndex', _parseInt(token('zIndex.base', 0)) + 1);
    },
    '&[data-popper-reference-hidden=true]': {
      opacity: '0 !important',
      pointerEvents: 'none'
    },
    '&[data-popper-placement^="top"] .arrow': {
      bottom: function bottom(_ref3) {
        var token = _ref3.token;
        return token('popout.arrow.size', _parseInt(token('arrow.size', defaultArrowSize)) / -2);
      }
    },
    '&[data-popper-placement^="right"] .arrow': {
      left: function left(_ref4) {
        var token = _ref4.token;
        return token('popout.arrow.size', _parseInt(token('arrow.size', defaultArrowSize)) / -2);
      }
    },
    '&[data-popper-placement^=bottom] .arrow': {
      top: function top(_ref5) {
        var token = _ref5.token;
        return token('popout.arrow.size', _parseInt(token('arrow.size', defaultArrowSize)) / -2);
      }
    },
    '&[data-popper-placement^="left"] .arrow': {
      right: function right(_ref6) {
        var token = _ref6.token;
        return token('popout.arrow.size', _parseInt(token('arrow.size', defaultArrowSize)) / -2);
      }
    }
  },
  arrow: {
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: 1,
      transform: 'rotate(45deg)'
    }
  }
});
export function Tether(_ref7) {
  var _context, _ref8, _attributes$popper;

  var children = _ref7.children,
      propIsOpen = _ref7.isOpen,
      _ref7$disabled = _ref7.disabled,
      disabled = _ref7$disabled === void 0 ? false : _ref7$disabled,
      _ref7$placement = _ref7.placement,
      placement = _ref7$placement === void 0 ? 'bottom' : _ref7$placement,
      _ref7$arrowSize = _ref7.arrowSize,
      arrowSize = _ref7$arrowSize === void 0 ? defaultArrowSize : _ref7$arrowSize,
      distanceProp = _ref7.distance,
      _ref7$overflowPadding = _ref7.overflowPadding,
      overflowPadding = _ref7$overflowPadding === void 0 ? 12 : _ref7$overflowPadding,
      _ref7$modifiers = _ref7.modifiers,
      modifiers = _ref7$modifiers === void 0 ? [] : _ref7$modifiers,
      _ref7$onToggle = _ref7.onToggle,
      onToggle = _ref7$onToggle === void 0 ? noop : _ref7$onToggle;
  var s = useStyles(defaultStyles);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      referenceEl = _useState2[0],
      setReferenceEl = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      popperEl = _useState4[0],
      setPopperEl = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      arrowEl = _useState6[0],
      setArrowEl = _useState6[1];

  var arrowHypot = _Math$hypot(arrowSize, arrowSize);

  var distance = distanceProp || Math.round(arrowHypot / 2) + defaultArrowMargin; // Ideally this is border radius + the arrow hypotenuse - arrow size
  // Border radius token is in `rem` and popperjs needs a number

  var arrowPadding = arrowHypot - arrowSize + defaultArrowPadding;

  var _usePopper = usePopper(referenceEl, popperEl, {
    placement: placement,
    modifiers: _concatInstanceProperty(_context = [{
      name: 'offset',
      enabled: true,
      options: {
        offset: [0, distance]
      }
    }, {
      name: 'preventOverflow',
      enabled: true,
      options: {
        padding: overflowPadding
      }
    }, {
      name: 'arrow',
      enabled: true,
      options: {
        element: arrowEl,
        padding: arrowPadding
      }
    }, {
      name: 'flip',
      enabled: true
    }, {
      name: 'hide',
      enabled: true
    }]).call(_context, _toConsumableArray(modifiers))
  }),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes;

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isOpen = _useState8[0],
      setOpen = _useState8[1];

  var actualIsOpen = propIsOpen !== null && propIsOpen !== void 0 ? propIsOpen : isOpen;
  var toggle = useCallback(function () {
    setOpen(function (prevIsOpen) {
      return !prevIsOpen;
    });
  }, []);
  var contentClicked = useRef(false); // We need to figure out if we're clicking on something
  // inside the popout even if the actual element is
  // portalled and absolutely positioned

  function handleCancelExit() {
    contentClicked.current = true;
  }

  useEffect(function () {
    onToggle(actualIsOpen);
  }, [actualIsOpen, onToggle]);
  useEffect(function () {
    function handleOutsideClick(e) {
      var isReferenceClick = referenceEl === null || referenceEl === void 0 ? void 0 : referenceEl.contains(e.target);

      if (!isReferenceClick && !contentClicked.current) {
        setOpen(false);
      }

      contentClicked.current = false;
    }

    function handleKeyDown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        setOpen(false);
      }
    }

    if (actualIsOpen) {
      _setTimeout(function () {
        window.document.addEventListener('click', handleOutsideClick);
        window.document.addEventListener('keydown', handleKeyDown);
      }, 0);

      return function () {
        window.document.removeEventListener('click', handleOutsideClick);
        window.document.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [actualIsOpen, referenceEl]);
  var referenceProps = {
    ref: setReferenceEl,
    tabIndex: disabled ? undefined : 0
  };

  var popperProps = _objectSpread(_objectSpread(_objectSpread({}, s.with('popper')(styles === null || styles === void 0 ? void 0 : styles.popper)), attributes === null || attributes === void 0 ? void 0 : attributes.popper), {}, {
    ref: setPopperEl,
    onPointerDown: handleCancelExit,
    onClickCapture: handleCancelExit
  });

  var arrowProps = _objectSpread(_objectSpread(_objectSpread({}, s.with('arrow')(_objectSpread(_objectSpread({}, styles.arrow), {}, {
    width: arrowSize,
    height: arrowSize,
    className: 'arrow'
  }))), attributes.arrow), {}, {
    ref: setArrowEl
  });

  var actualPlacement = (_ref8 = attributes === null || attributes === void 0 ? void 0 : (_attributes$popper = attributes.popper) === null || _attributes$popper === void 0 ? void 0 : _attributes$popper['data-popper-placement']) !== null && _ref8 !== void 0 ? _ref8 : placement;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children({
    isOpen: disabled ? false : actualIsOpen,
    placement: actualPlacement,
    referenceProps: referenceProps,
    popperProps: popperProps,
    arrowProps: arrowProps,
    toggle: toggle,
    setOpen: setOpen
  }));
}